import { constants } from "../service";

const initialState = {
  loading: true,
  faq: { id: null, isGood: null, sended: false },
  errorRequest: false,
};

export default function courseContentReducer(state = initialState, action) {
  switch (action.type) {
    case constants.GET_FAQ_FEEDBACK:
      return { ...state, loading: true };
    case constants.GET_FAQ_FEEDBACK_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        faq: {
          isGood: data?.isGood,
          id: data?.id,
          sended: false,
        },
      };
    }
    case constants.SET_FAQ_FEEDBACK:
      return { ...state, loading: true, sended: true };
    case constants.SET_FAQ_FEEDBACK_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        faq: {
          isGood: data?.isGood,
          id: data?.id,
          sended: true,
        },
      };
    }
    case constants.GET_FAQ_FEEDBACK_ERROR || constants.SET_FAQ_FEEDBACK_ERROR:
      return { ...state, loading: false, errorRequest: true };

    default:
      return state;
  }
}
